const instance = ($el: HTMLElement) => {
  const elementsToWrapSelector = $el.dataset.wrap;
  const wrapClass = $el.dataset.wrapClass;

  if (!elementsToWrapSelector || !wrapClass) {
    return;
  }

  const elementsToWrap = Array.from(
    $el.querySelectorAll(elementsToWrapSelector),
  ).filter((el) => !el.closest(`.${wrapClass}`));

  if (!elementsToWrap.length) {
    return;
  }

  elementsToWrap.forEach((el) => {
    if (!el.parentNode) {
      return;
    }

    const wrapper = document.createElement("div");
    wrapper.classList.add(wrapClass);

    el.parentNode.insertBefore(wrapper, el);

    wrapper.appendChild(el);
  });
};

export default () => {
  const $el = document.querySelectorAll<HTMLElement>(".js-add-wrapper");

  $el.forEach(($element) => {
    instance($element);
  });
};
